import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';

const ActionPanelFilterAddressButton = ({
  className = '',
  filterClassName = '',
  id = '',
  isDeliveryFilter = false,
  onChange = null,
  value = [],
  strings,
}) => {
  const addressAttribute = isDeliveryFilter ? 'delivery_address' : 'pickup_address';
  const text = strings[addressAttribute].text;
  const subText = value || [];

  return (
    <Components.ActionPanel.DropdownButton
      className={className}
      id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__dropdown-button`}
      showArrow
      subText={subText}
      text={text}
    >
      <Components.ActionPanel.FilterTagSearch
        className={filterClassName}
        id={Utils.Helper.isNullOrUndefined(id) ? undefined : `${id}__filter-tag-dropdown`}
        onChange={v => onChange(v)}
        placeholder={strings[addressAttribute].placeholder}
        value={value}
      />
    </Components.ActionPanel.DropdownButton>
  );
};

ActionPanelFilterAddressButton.displayName = 'Action Panel Filter Address Button';

ActionPanelFilterAddressButton.propTypes = {
  className: PropTypes.string,
  filterClassName: PropTypes.string,
  id: PropTypes.string,
  isDeliveryFilter: PropTypes.bool,
  onChange: PropTypes.func,
  strings: PropTypes.shape({
    pickup_address: PropTypes.shape({
      text: PropTypes.string,
      placeholder: PropTypes.string,
    }).isRequired,
    delivery_address: PropTypes.shape({
      text: PropTypes.string,
      placeholder: PropTypes.string,
    }).isRequired,
  }).isRequired,
  value: PropTypes.string,
};

export default translate('Task.filter.address')(ActionPanelFilterAddressButton);
